import { useSeo } from "@/lib/seo";
import { ROUTES } from "@/lib/routes";
import { Link, useSearchParams } from "react-router-dom";
import { ArrowLeft, BookOpen } from "lucide-react";
import { useT } from "@/i18n";
import Logo from "@/components/Logo";
import Background from "@/components/landing/Background";
import UploadBox from "@/components/landing/UploadBox";
import SignActions from "@/components/landing/SignActions";

export default function Upload() {
  const { t } = useT();
  useSeo({ title: "Wyślij podpisany dokument", description: "Skrzynka wirtualnego biura Twoje Biuro w Warszawie — prześlij dokumenty podpisane profilem zaufanym lub podpisem kwalifikowanym. Automatyczna weryfikacja podpisu.", path: ROUTES.upload, breadcrumbs: [{ name: "Wyślij podpisany dokument", path: ROUTES.upload }] });
  const [params] = useSearchParams();
  const orderId = params.get("order") || "";

  return (
    <div data-testid="upload-page" className="min-h-screen text-foreground">
      <Background />
      <header className="sticky top-0 z-40 border-b border-border bg-card/80 backdrop-blur-xl">
        <div className="max-w-5xl mx-auto px-4 sm:px-8 h-16 flex items-center justify-between">
          <Link to="/" aria-label="Twoje Biuro"><Logo className="h-8 text-slate-900 dark:text-white" showTagline={false} /></Link>
          <Link to="/biuro-wirtualne-warszawa/dokumenty" data-testid="upload-back-link" className="inline-flex items-center gap-1.5 text-xs font-semibold border border-border rounded-full px-4 py-2 hover:bg-muted transition-colors">
            <ArrowLeft size={13} /> {t.docs.back_list}
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 sm:px-8 py-12 sm:py-20">
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-muted-foreground font-semibold">
          <span aria-hidden="true" className="inline-block w-6 h-[3px] rounded-full bg-brand-yellow mr-3 align-middle" />{t.docs.title}
        </p>
        <h1 className="font-display font-bold tracking-tight text-4xl sm:text-5xl mt-4">{t.upload.title}</h1>
        <p className="text-base text-muted-foreground mt-4 leading-relaxed">{t.upload.sub}</p>
        <div className="mt-8">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted-foreground mb-3">{t.upload.step1}</p>
          <SignActions showUpload={false} compact />
        </div>
        <div className="mt-8 bg-white/85 dark:bg-slate-900/85 backdrop-blur border border-slate-200 dark:border-slate-800 rounded-3xl p-6 sm:p-8">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted-foreground mb-4">{t.upload.step2}</p>
          <UploadBox orderId={orderId} />
        </div>
        <Link to="/biuro-wirtualne-warszawa/dokumenty#biuro-wirtualne-poradnik" data-testid="upload-guide-cta" className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-brand-teal hover:text-brand-tealDark transition-colors">
          <BookOpen size={15} /> {t.docs.guide_cta}
        </Link>
      </main>
    </div>
  );
}
